import React from 'react'
import { FlexWrapper, Container, GradiantButton1, Text5} from '../../../../Components/Common/index.js'
import { Heading, Section1MainWrapper } from './styles.js'
const Section1 = () => {
    return (
      <Section1MainWrapper>
        <Container>
          <FlexWrapper direction={"column"} justify={"center"} align={"center"}>
            <Heading weight={700} fontFamily={"Inter"}>
              Let Escribelo Write Your
              <br /> Marketing Copy.
            </Heading>
            <Text5 color={"white"} margin={"20px 0px"} weight={600}>
              Say "Hey!" to escribelo. Your AI writing assistant makes it fast &
              easy to write effective <br /> copy for your blog, social media, website,
              and more!
            </Text5>
            <GradiantButton1 color={"white"} width={"300px"} height={"70px"} margin={"20px auto"}>Get Started</GradiantButton1>
          </FlexWrapper>
        </Container>
      </Section1MainWrapper>
    );
}

export default Section1
